
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, reactive, ref, watch, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";
import moment from "moment";
import TableTab from "@/components/kt-datatable/TableTab.vue";

export default defineComponent({
  name: "DataTable",

  components: {
    TableTab,
  },
  setup() {
    const pageheader = "Historic Consumption, Cost and CO2 - Gas";
    const accountId = computed(() => store.getters.AccountId);
    const sumCo2 = ref(0.0);
    const sumCost = ref("0.0");
    const sumKwh = ref(0.0);
    const SiteDetails = ref();
    const tableValues = ref([]);
    const initHistoricConsumption = ref([]);
    const fromDate = ref(new Date());
    const toDate = ref(new Date());
    const addition = ref(false);
    const removal = ref(false);
    const isViewClicked = ref(false);
    const searchInput = ref();
    const loading = ref<boolean>(false);
    interface Tableheader {
      name: string;
      key: string;
      sortable: boolean;
    }

    const downloadurl = "api/Downloadfile/generateGasHistoric";
    const downloadprops = ref();
    const TableHeaders = ref<Array<Tableheader>>();
    const OriginalTableHeaders = ref<Array<Tableheader>>();
    const colnames = ref();
    const initHistoric = ref([]);
    const disableDates = (time) => {
      const currentDate = new Date();
      const selectedDate = new Date(
        time.getFullYear(),
        time.getMonth(),
        time.getDate()
      );
      return selectedDate > currentDate;
    };

    const series = reactive([{}]);
    const labels = ref([""]);
    const eboptions = {
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
          height: 350,
          type: "line",
        },
        stroke: {
          show: true,
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0,
          curve: "smooth",
        },
        title: {
          text: "",
        },
        dataLabels: {
          enabled: false,
          //enabledOnSeries: [1],
        },
        labels: [
          "Jan 2001",
          "Feb 2001",
          "Mar 2001",
          "Apr 2001",
          "May 2001",
          "Jun 2001",
          "Jul 2001",
          "Aug 2001",
          "Sep 2001",
          "Oct 2001",
          "Nov 2001",
          "Dec 2001",
          "Jan 2002",
          "Feb 2002",
          "Mar 2002",
          "Apr 2002",
          "May 2002",
          "Jun 2002",
          "Jul 2002",
          "Aug 2002",
          "Sep 2002",
          "Oct 2002",
          "Nov 2002",
          "Dec 2002",
          "Jan 2003",
          "Feb 2003",
          "Mar 2003",
          "Apr 2003",
          "May 2003",
          "Jun 2003",
          "Jul 2003",
          "Aug 2003",
          "Sep 2003",
          "Oct 2003",
          "Nov 2003",
          "Dec 2003",
          "Jan 2004",
          "Feb 2004",
          "Mar 2004",
          "Apr 2004",
          "May 2004",
          "Jun 2004",
          "Jul 2004",
          "Aug 2004",
          "Sep 2004",
          "Oct 2004",
          "Nov 2004",
          "Dec 2004",
          "Jan 2005",
          "Feb 2005",
          "Mar 2005",
          "Apr 2005",
          "May 2005",
          "Jun 2005",
          "Jul 2005",
          "Aug 2005",
          "Sep 2005",
          "Oct 2005",
          "Nov 2005",
          "Dec 2005",
          "Jan 2006",
          "Feb 2006",
          "Mar 2006",
          "Apr 2006",
          "May 2006",
          "Jun 2006",
          "Jul 2006",
          "Aug 2006",
          "Sep 2006",
          "Oct 2006",
          "Nov 2006",
          "Dec 2006",
          "Jan 2007",
          "Feb 2007",
          "Mar 2007",
          "Apr 2007",
          "May 2007",
          "Jun 2007",
          "Jul 2007",
          "Aug 2007",
          "Sep 2007",
          "Oct 2007",
          "Nov 2007",
          "Dec 2007",
          "Jan 2008",
          "Feb 2008",
          "Mar 2008",
          "Apr 2008",
          "May 2008",
          "Jun 2008",
          "Jul 2008",
          "Aug 2008",
          "Sep 2008",
          "Oct 2008",
          "Nov 2008",
          "Dec 2008",
          "Jan 2009",
          "Feb 2009",
          "Mar 2009",
          "Apr 2009",
          "May 2009",
          "Jun 2009",
          "Jul 2009",
          "Aug 2009",
          "Sep 2009",
          "Oct 2009",
          "Nov 2009",
          "Dec 2009",
          "Jan 2010",
          "Feb 2010",
          "Mar 2010",
          "Apr 2010",
          "May 2010",
          "Jun 2010",
          "Jul 2010",
          "Aug 2010",
          "Sep 2010",
          "Oct 2010",
          "Nov 2010",
          "Dec 2010",
          "Jan 2011",
          "Feb 2011",
          "Mar 2011",
          "Apr 2011",
          "May 2011",
          "Jun 2011",
          "Jul 2011",
          "Aug 2011",
          "Sep 2011",
          "Oct 2011",
          "Nov 2011",
          "Dec 2011",
          "Jan 2012",
          "Feb 2012",
          "Mar 2012",
          "Apr 2012",
          "May 2012",
          "Jun 2012",
          "Jul 2012",
          "Aug 2012",
          "Sep 2012",
          "Oct 2012",
          "Nov 2012",
          "Dec 2012",
          "Jan 2013",
          "Feb 2013",
          "Mar 2013",
          "Apr 2013",
          "May 2013",
          "Jun 2013",
          "Jul 2013",
          "Aug 2013",
          "Sep 2013",
          "Oct 2013",
          "Nov 2013",
          "Dec 2013",
          "Jan 2014",
          "Feb 2014",
          "Mar 2014",
          "Apr 2014",
          "May 2014",
          "Jun 2014",
          "Jul 2014",
          "Aug 2014",
          "Sep 2014",
          "Oct 2014",
          "Nov 2014",
          "Dec 2014",
          "Jan 2015",
          "Feb 2015",
          "Mar 2015",
          "Apr 2015",
          "May 2015",
          "Jun 2015",
          "Jul 2015",
          "Aug 2015",
          "Sep 2015",
          "Oct 2015",
          "Nov 2015",
          "Dec 2015",
          "Jan 2016",
          "Feb 2016",
          "Mar 2016",
          "Apr 2016",
          "May 2016",
          "Jun 2016",
          "Jul 2016",
          "Aug 2016",
          "Sep 2016",
          "Oct 2016",
          "Nov 2016",
          "Dec 2016",
          "Jan 2017",
          "Feb 2017",
          "Mar 2017",
          "Apr 2017",
          "May 2017",
          "Jun 2017",
          "Jul 2017",
          "Aug 2017",
          "Sep 2017",
          "Oct 2017",
          "Nov 2017",
          "Dec 2017",
          "Jan 2018",
          "Feb 2018",
          "Mar 2018",
          "Apr 2018",
          "May 2018",
          "Jun 2018",
          "Jul 2018",
          "Aug 2018",
          "Sep 2018",
          "Oct 2018",
          "Nov 2018",
          "Dec 2018",
          "Jan 2019",
          "Feb 2019",
          "Mar 2019",
          "Apr 2019",
          "May 2019",
          "Jun 2019",
          "Jul 2019",
          "Aug 2019",
          "Sep 2019",
          "Oct 2019",
          "Nov 2019",
          "Dec 2019",
          "Jan 2020",
          "Feb 2020",
          "Mar 2020",
          "Apr 2020",
          "May 2020",
          "Jun 2020",
          "Jul 2020",
          "Aug 2020",
          "Sep 2020",
          "Oct 2020",
          "Nov 2020",
          "Dec 2020",
          "Jan 2021",
          "Feb 2021",
          "Mar 2021",
          "Apr 2021",
          "May 2021",
          "Jun 2021",
          "Jul 2021",
          "Aug 2021",
          "Sep 2021",
          "Oct 2021",
          "Nov 2021",
          "Dec 2021",
          "Jan 2022",
          "Feb 2022",
          "Mar 2022",
          "Apr 2022",
          "May 2022",
          "Jun 2022",
          "Jul 2022",
          "Aug 2022",
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
          "Dec 2022",
          "Jan 2023",
          "Feb 2023",
          "Mar 2023",
          "Apr 2023",
          "May 2023",
          "Jun 2023",
          "Jul 2023",
          "Aug 2023",
          "Sep 2023",
          "Oct 2023",
          "Nov 2023",
          "Dec 2023",
          "Jan 2024",
          "Feb 2024",
          "Mar 2024",
          "Apr 2024",
          "May 2024",
          "Jun 2024",
          "Jul 2024",
          "Aug 2024",
          "Sep 2024",
          "Oct 2024",
          "Nov 2024",
          "Dec 2024",
          "Jan 2025",
          "Feb 2025",
          "Mar 2025",
          "Apr 2025",
          "May 2025",
          "Jun 2025",
          "Jul 2025",
          "Aug 2025",
          "Sep 2025",
          "Oct 2025",
          "Nov 2025",
          "Dec 2025",
          "Jan 2026",
          "Feb 2026",
          "Mar 2026",
          "Apr 2026",
          "May 2026",
          "Jun 2026",
          "Jul 2026",
          "Aug 2026",
          "Sep 2026",
          "Oct 2026",
          "Nov 2026",
          "Dec 2026",
          "Jan 2027",
          "Feb 2027",
          "Mar 2027",
          "Apr 2027",
          "May 2027",
          "Jun 2027",
          "Jul 2027",
          "Aug 2027",
          "Sep 2027",
          "Oct 2027",
          "Nov 2027",
          "Dec 2027",
          "Jan 2028",
          "Feb 2028",
          "Mar 2028",
          "Apr 2028",
          "May 2028",
          "Jun 2028",
          "Jul 2028",
          "Aug 2028",
          "Sep 2028",
          "Oct 2028",
          "Nov 2028",
          "Dec 2028",
          "Jan 2029",
          "Feb 2029",
          "Mar 2029",
          "Apr 2029",
          "May 2029",
          "Jun 2029",
          "Jul 2029",
          "Aug 2029",
          "Sep 2029",
          "Oct 2029",
          "Nov 2029",
          "Dec 2029",
          "Jan 2030",
          "Feb 2030",
          "Mar 2030",
          "Apr 2030",
          "May 2030",
          "Jun 2030",
          "Jul 2030",
          "Aug 2030",
          "Sep 2030",
          "Oct 2030",
          "Nov 2030",
          "Dec 2030",
          "Jan 2031",
          "Feb 2031",
          "Mar 2031",
          "Apr 2031",
          "May 2031",
          "Jun 2031",
          "Jul 2031",
          "Aug 2031",
          "Sep 2031",
          "Oct 2031",
          "Nov 2031",
          "Dec 2031",
          "Jan 2032",
          "Feb 2032",
          "Mar 2032",
          "Apr 2032",
          "May 2032",
          "Jun 2032",
          "Jul 2032",
          "Aug 2032",
          "Sep 2032",
          "Oct 2032",
          "Nov 2032",
          "Dec 2032",
          "Jan 2033",
          "Feb 2033",
          "Mar 2033",
          "Apr 2033",
          "May 2033",
          "Jun 2033",
          "Jul 2033",
          "Aug 2033",
          "Sep 2033",
          "Oct 2033",
          "Nov 2033",
          "Dec 2033",
          "Jan 2034",
          "Feb 2034",
          "Mar 2034",
          "Apr 2034",
          "May 2034",
          "Jun 2034",
          "Jul 2034",
          "Aug 2034",
          "Sep 2034",
          "Oct 2034",
          "Nov 2034",
          "Dec 2034",
          "Jan 2035",
          "Feb 2035",
          "Mar 2035",
          "Apr 2035",
          "May 2035",
          "Jun 2035",
          "Jul 2035",
          "Aug 2035",
          "Sep 2035",
          "Oct 2035",
          "Nov 2035",
          "Dec 2035",
          "Jan 2036",
          "Feb 2036",
          "Mar 2036",
          "Apr 2036",
          "May 2036",
          "Jun 2036",
          "Jul 2036",
          "Aug 2036",
          "Sep 2036",
          "Oct 2036",
          "Nov 2036",
          "Dec 2036",
          "Jan 2037",
          "Feb 2037",
          "Mar 2037",
          "Apr 2037",
          "May 2037",
          "Jun 2037",
          "Jul 2037",
          "Aug 2037",
          "Sep 2037",
          "Oct 2037",
          "Nov 2037",
          "Dec 2037",
          "Jan 2038",
          "Feb 2038",
          "Mar 2038",
          "Apr 2038",
          "May 2038",
          "Jun 2038",
          "Jul 2038",
          "Aug 2038",
          "Sep 2038",
          "Oct 2038",
          "Nov 2038",
          "Dec 2038",
          "Jan 2039",
          "Feb 2039",
          "Mar 2039",
          "Apr 2039",
          "May 2039",
          "Jun 2039",
          "Jul 2039",
          "Aug 2039",
          "Sep 2039",
          "Oct 2039",
          "Nov 2039",
          "Dec 2039",
          "Jan 2040",
          "Feb 2040",
          "Mar 2040",
          "Apr 2040",
          "May 2040",
          "Jun 2040",
          "Jul 2040",
          "Aug 2040",
          "Sep 2040",
          "Oct 2040",
          "Nov 2040",
          "Dec 2040",
        ],
        // xaxis: {
        //   // type: "datetime",

        //   //   //  datetimeUTC: false,
        //   //   // formatter: function (val, timestamp) {
        //   //   //   return moment(new Date(timestamp)).format("MMM YYYY");
        //   //   // },
        //   //   style: {
        //   //     colors: "#9899ac",
        //   //   },
        //   //   [

        //   //   ]

        //   // },

        //   axisBorder: {
        //     show: false,
        //   },
        //   axisTicks: {
        //     show: false,
        //   },
        // },
        yaxis: [
          {
            seriesName: "Consumption (kWh)",
            title: {
              text: "Consumption (kWh) and CO₂ (kgCO₂e)",
            },
          },
          {
            seriesName: "Consumption (kWh)",
            show: false,
            opposite: false,
          },
          {
            opposite: true,
            seriesName: "Cost (£)",
            title: {
              text: " Cost (£) ",
            },
          },
        ],
      },
    };
    
    const staticlabels = eboptions.chartOptions.labels;
    onMounted(() => {
      setCurrentPageBreadcrumbs(" Historic Consumption, Cost and CO2 - Gas", [
        "NA",
      ]);

      addition.value = false;
      removal.value = false;
    });

    async function getContent() {
      let isGraph = true;
      if (removal.value == false && addition.value == false) {
        isGraph = true;
      } else if (addition.value == true) {
        isGraph = true;
      } else if (removal.value == true) {
        isGraph = false;
      }
      addition.value = false;
      removal.value = false;
      eboptions.chartOptions.labels = staticlabels;
      loading.value = true;
      const fromdateval: any = fromDate.value;
      const toDateval: any = toDate.value;
      let domainName = store.getters.DomainName.toLowerCase();
      const accountInfo: any = {
        accountid: accountId.value,
        fromdate: moment(fromdateval).format("YYYY-MM-DD 00:00:00"),
        todate: moment(toDateval).format("YYYY-MM-DD 00:00:00"),
        locations: searchInput.value,
        DomainName: domainName,
      };
      downloadprops.value = accountInfo;
      isViewClicked.value = true;
      ApiService.post("api/historicconsumption/hc_monthlygas", accountInfo)
        .then((resp) => {
          series.splice(0);
          sumCo2.value = resp.data.summary.co2;
          sumCost.value = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
          }).format(resp.data.summary.cost);

          // sumCost.value = resp.data.summary.cost;
          sumKwh.value = resp.data.summary.consumption;

          SiteDetails.value = resp.data.siteDetails;
          TableHeaders.value = resp.data.detailsheader.map((a) => ({
            name: a.header,
            key: a.header,
            sortable: true,
          }));
          colnames.value = resp.data.detailsheader.map((a) => a.header);
          OriginalTableHeaders.value = resp.data.detailsheader.map((a) => ({
            name: a.header,
            key: a.header,
            sortable: true,
          }));

          tableValues.value = resp.data.dsiteDetails.map((a) => a);
          if (isGraph == true) {
            addition.value = true;
          } else {
            removal.value = true;
          }
          eboptions.chartOptions.labels.splice(
            0,
            eboptions.chartOptions.labels.indexOf(resp.data.yearsmonthsum[0])
          );
          eboptions.chartOptions.labels = resp.data.yearsmonthsum;

          series.push({
            name: "Consumption (kWh)",
            type: "column",
            data: resp.data.usage,
          });
          series.push({
            name: "CO₂ (kgCO₂e)",
            type: "line",
            data: resp.data.co2,
          });
          series.push({
            name: "Cost (£)",
            type: "line",
            data: resp.data.cost,
          });
          // labels.value = resp.data.monthlyDetails.map((a) => a.yearsmonthsum);
          // series.push({
          //   name: "Consumption KWh and co2 (KgCox)",
          //   type: "column",
          //   data: resp.data.monthlyDetails.map((a) => [
          //     new Date(`${a.years}-${a.monthid}-01`),
          //     a.usage,
          //   ]),
          // });
          // series.push({
          //   name: "Co2 (Kgco2)",
          //   type: "line",
          //   data: resp.data.monthlyDetails.map((a) => [
          //     new Date(`${a.years}-${a.monthid}-01`),
          //     a.co2,
          //   ]),
          // });
          // series.push({
          //   name: "Cost ",
          //   type: "line",
          //   data: resp.data.monthlyDetails.map((a) => [
          //     new Date(`${a.years}-${a.monthid}-01`),
          //     a.cost,
          //   ]),
          // });

          loading.value = false;
        })
        .catch((a) => {
          loading.value = false;
        });
    }

    function openAssetAddition() {
      addition.value = true;
      removal.value = false;
    }
    function openAssetRemoval() {
      addition.value = false;
      removal.value = true;
    }

    return {
      labels,
      series,
      getContent,
      SiteDetails,
      TableHeaders,
      sumCo2,
      sumCost,
      sumKwh,
      colnames,
      fromDate,
      toDate,
      openAssetAddition,
      openAssetRemoval,
      addition,
      removal,
      tableValues,
      eboptions,
      loading,
      OriginalTableHeaders,
      pageheader,
      disableDates,
      isViewClicked,
      downloadurl,
      downloadprops,
      staticlabels,
      searchInput,
    };
  },
});
